import React from "react";
import { Text, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import tw from "twrnc";

import { colors, radius, text } from "./theme";

// Boxed notes inside a settings screen. One look per meaning:
//   info     context the user should know (rooms share tickets, analytics retention)
//   warning  something needs attention before it works (test environment, missing setup)
//   success  a finished setup (Stripe connected, fundraiser saved)
//   danger   an error the user has to act on
//   neutral  a quiet summary (what a new room copies, what buyers see)
const TONES = {
  info: {
    bg: colors.infoTint,
    fg: colors.info,
    border: "#BFDBFE",
    icon: "information-circle",
  },
  warning: {
    bg: colors.warningTint,
    fg: colors.warning,
    border: "#FDE68A",
    icon: "alert-circle",
  },
  success: {
    bg: colors.successTint,
    fg: colors.success,
    border: "#BBF7D0",
    icon: "checkmark-circle",
  },
  danger: {
    bg: colors.dangerTint,
    fg: colors.danger,
    border: "#FECACA",
    icon: "alert-circle",
  },
  neutral: {
    bg: colors.surface,
    fg: colors.ink,
    border: colors.divider,
    icon: null,
  },
};

const Callout = ({
  tone = "info",
  title,
  children,
  action,
  icon,
  style,
  live,
}) => {
  const t = TONES[tone] || TONES.info;
  const iconName = icon === undefined ? t.icon : icon;
  return (
    <View
      accessibilityRole={tone === "danger" ? "alert" : undefined}
      accessibilityLiveRegion={live ? "polite" : undefined}
      style={[
        tw`flex-row p-3`,
        {
          backgroundColor: t.bg,
          borderColor: t.border,
          borderWidth: 1,
          borderRadius: radius.control,
        },
        style,
      ]}
    >
      {!!iconName && (
        <Ionicons
          name={iconName}
          size={18}
          color={t.fg}
          style={tw`mr-2 mt-[1px]`}
        />
      )}
      <View style={tw`flex-1`}>
        {!!title && (
          <Text style={[text.bodyStrong, { color: t.fg }]}>{title}</Text>
        )}
        {typeof children === "string" ? (
          <Text style={[text.body, { color: t.fg }, !!title && tw`mt-0.5`]}>
            {children}
          </Text>
        ) : (
          children
        )}
        {!!action && <View style={tw`mt-3`}>{action}</View>}
      </View>
    </View>
  );
};

export default Callout;
